var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45310_200789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8724 1.00781H1.86872C1.13221 1.00781 0.535156 1.60487 0.535156 2.34138V23.345C0.535156 24.0815 1.13221 24.6786 1.86872 24.6786H22.8724C23.6089 24.6786 24.2059 24.0815 24.2059 23.345V2.34138C24.2059 1.60487 23.6089 1.00781 22.8724 1.00781Z",
    stroke: "#D9D9D9",
    strokeWidth: 0.333391
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8689 19.5078H3.86591C3.77385 19.5078 3.69922 19.5824 3.69922 19.6745C3.69922 19.7666 3.77385 19.8412 3.86591 19.8412H20.8689C20.9609 19.8412 21.0355 19.7666 21.0355 19.6745C21.0355 19.5824 20.9609 19.5078 20.8689 19.5078Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0352 11.4141H21.0365",
    stroke: "#4D4D4D",
    strokeWidth: 0.833477,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0352 13.4141H21.0365",
    stroke: "#4D4D4D",
    strokeWidth: 0.833477,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0352 15.4141H21.0365",
    stroke: "#4D4D4D",
    strokeWidth: 0.833477,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2793 6.5C13.4961 6.5 13.6746 6.66021 13.6974 6.86603L13.6999 6.91079V8.52744C13.6999 8.75431 13.5116 8.93823 13.2793 8.93823C13.0625 8.93823 12.884 8.77802 12.8612 8.5722L12.8587 8.52744L12.8584 7.32157H4.87238V8.52744C4.87238 8.73919 4.70836 8.91352 4.49764 8.93582L4.45182 8.93823C4.23503 8.93823 4.05655 8.77802 4.03372 8.5722L4.03125 8.52744V6.91079C4.03125 6.69904 4.19527 6.52471 4.40599 6.50241L4.45182 6.5H13.2793Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5199 15.125C10.7522 15.125 10.9405 15.3089 10.9405 15.5358C10.9405 15.7475 10.7765 15.9219 10.5658 15.9442L10.5199 15.9466H7.20963C6.97736 15.9466 6.78906 15.7627 6.78906 15.5358C6.78906 15.324 6.95309 15.1497 7.1638 15.1274L7.20963 15.125H10.5199Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86588 6.5C9.08267 6.5 9.26114 6.66021 9.28398 6.86603L9.28644 6.91079V15.533C9.28644 15.7598 9.09815 15.9438 8.86588 15.9438C8.64909 15.9438 8.47061 15.7835 8.44778 15.5777L8.44531 15.533V6.91079C8.44531 6.68391 8.63361 6.5 8.86588 6.5Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2793 6.5C13.4961 6.5 13.6746 6.66021 13.6974 6.86603L13.6999 6.91079V8.52744C13.6999 8.75431 13.5116 8.93823 13.2793 8.93823C13.0625 8.93823 12.884 8.77802 12.8612 8.5722L12.8587 8.52744L12.8584 7.32157H4.87238V8.52744C4.87238 8.73919 4.70836 8.91352 4.49764 8.93582L4.45182 8.93823C4.23503 8.93823 4.05655 8.77802 4.03372 8.5722L4.03125 8.52744V6.91079C4.03125 6.69904 4.19527 6.52471 4.40599 6.50241L4.45182 6.5H13.2793Z",
    fill: "#4D4D4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5199 15.125C10.7522 15.125 10.9405 15.3089 10.9405 15.5358C10.9405 15.7475 10.7765 15.9219 10.5658 15.9442L10.5199 15.9466H7.20963C6.97736 15.9466 6.78906 15.7627 6.78906 15.5358C6.78906 15.324 6.95309 15.1497 7.1638 15.1274L7.20963 15.125H10.5199Z",
    fill: "#4D4D4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86588 6.5C9.08267 6.5 9.26114 6.66021 9.28398 6.86603L9.28644 6.91079V15.533C9.28644 15.7598 9.09815 15.9438 8.86588 15.9438C8.64909 15.9438 8.47061 15.7835 8.44778 15.5777L8.44531 15.533V6.91079C8.44531 6.68391 8.63361 6.5 8.86588 6.5Z",
    fill: "#4D4D4D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45310_200789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0042,
    height: 24.0042,
    fill: "white",
    transform: "translate(0.367188 0.835938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiLineIcon);
export default __webpack_public_path__ + "static/media/multi-line-icon.7275185e543e96c087442e82a521e1e0.svg";
export { ForwardRef as ReactComponent };